import React, { useEffect, useRef, useState } from 'react'

export default function PulseAI() {
  const hasOpened = useRef(false)
  const [showReopen, setShowReopen] = useState(false)

  const openPulseAI = () => {
    const newTab = window.open(
      "https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/embed/share/accounts/764946308314/chatagents/2c8ca2b9-4cd6-4b73-8a9f-ffc38e8270fe",
      "_blank"
    )
    if (newTab) {
      newTab.focus()
      setShowReopen(true)
    } else {
      // Pop-up was blocked
      setShowReopen(true)
    }
  }

  useEffect(() => {
    if (!hasOpened.current) {
      hasOpened.current = true
      openPulseAI()
    }
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f5f5f5',
        gap: '20px'
      }}
    >
      {!showReopen ? (
        <p style={{ fontSize: '18px', color: '#333' }}>Opening Pulse AI...</p>
      ) : (
        <>
          <p style={{ fontSize: '18px', color: '#333' }}>
            Pulse AI is Powered by Quick Suite and opened in a new tab
          </p>
          <button
            onClick={openPulseAI}
            style={{
              padding: '12px 28px',
              fontSize: '16px',
              cursor: 'pointer',
              backgroundColor: '#232f3e',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#37475a')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#232f3e')}
          >
            🔄 Reopen Pulse AI
          </button>
          <p style={{ fontSize: '14px', color: '#888' }}>
            Tab closed? Click above to reopen.
          </p>
        </>
      )}
    </div>
  )
}